import { createAsyncThunk } from "@reduxjs/toolkit";
import { QueryCacheKey } from "@reduxjs/toolkit/dist/query/core/apiState";
import { RootState } from "@/store/store";
import { budgetDetailsByIdEndpointSelector } from "@/store/budgets/selectors/details-drawer/budgetDetailsByIdEndpointSelector";
import { cloudChiprApi } from "@/services/cloudchipr.api";

export const invalidateBudgetDetailsCacheThunk = createAsyncThunk(
  "budgets/invalidateBudgetDetailsCache",
  (_, { dispatch, getState }) => {
    const state = getState() as RootState;

    const budgetDetailsArgs =
      budgetDetailsByIdEndpointSelector(state)?.originalArgs;
    const budgetDetailsArgsAsJson = JSON.stringify(budgetDetailsArgs);

    if (budgetDetailsArgs) {
      dispatch(
        cloudChiprApi.internalActions.removeQueryResult({
          queryCacheKey:
            `getUsersMeOrganisationsCurrentBudgetsByBudgetIdDetails(${budgetDetailsArgsAsJson})` as QueryCacheKey,
        }),
      );
    }
  },
);
